var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _g19, _g20, _g21, _g22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendarExam(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 70,
    height: 68.299,
    viewBox: "0 0 70 68.299",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:url(#a);}.b{clip-path:url(#w);}.c{clip-path:url(#y);}.d{clip-path:url(#aa);}.e{clip-path:url(#ac);}.f{clip-path:url(#ae);}.g{clip-path:url(#ag);}.h{clip-path:url(#ai);}.i{clip-path:url(#ak);}.j{clip-path:url(#am);}.k{clip-path:url(#ao);}.l{clip-path:url(#aq);}.m{clip-path:url(#as);}.n{clip-path:url(#au);}.o{clip-path:url(#aw);}.p{clip-path:url(#ay);}.q{clip-path:url(#ba);}.r{clip-path:url(#bc);}.s{clip-path:url(#be);}.t{clip-path:url(#bg);}.u{clip-path:url(#bi);}.v{clip-path:url(#bk);}.w{clip-path:url(#bm);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ff5f45"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff357d"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M96.616,107.156h0c.1.077.144.105.184.146l2.068,2.056-2.619.382c.126-.872.24-1.695.367-2.583m.548-1.566c.075-.08.167-.182.265-.281q5.2-5.2,10.4-10.4,1.415-1.406,2.842-2.8a1.86,1.86,0,0,1,2.738,0c1.448,1.269,1.266,2.454.041,3.66-4.278,4.211-8.49,8.487-12.725,12.74a4.288,4.288,0,0,0-.3.375v0l-1.114-1.144q5.463-5.464,10.991-10.991l-1.047-.994q-5.47,5.473-10.983,10.984ZM109.535,91.2,101.4,99.334c-.106.107-.221.208-.336.314L100,100.732c-.05.052-.152.165-.26.274q-2.014,2-4.019,4.022a.886.886,0,0,0-.278.418c-.295,1.957-.569,3.917-.858,5.948.53-.069,1.023-.128,1.516-.2,1.431-.2,2.863-.4,4.292-.621a1.083,1.083,0,0,0,.55-.292q2.016-2,4.022-4.019a2.478,2.478,0,0,0,.261-.366l1.118-1.063c.11-.091.238-.185.351-.3q4.078-4.083,8.164-8.161a3.3,3.3,0,0,0,1.067-2.4v-.059a3.29,3.29,0,0,0-.056-.574,3.979,3.979,0,0,0-1.318-2.139,3.607,3.607,0,0,0-2.517-1.158,3.543,3.543,0,0,0-2.5,1.158",
    transform: "translate(-94.583 -90.046)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "y"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M4.772,58.054h5.51v5.52l-5.51-5.52m22.4-42.609a1.28,1.28,0,0,0,.112-2.536c-2.4-.521-3.019-1.378-2.716-3.874H37.379c0,.476-.011.946,0,1.414a5.184,5.184,0,0,0,4.763,5,1.383,1.383,0,0,0,1.574-.831,1.272,1.272,0,0,0-.973-1.713c-2.413-.518-3.017-1.357-2.726-3.842H52.841c0,.445-.012.914,0,1.382a5.183,5.183,0,0,0,4.76,5,1.384,1.384,0,0,0,1.576-.827,1.272,1.272,0,0,0-.969-1.716c-2.415-.523-3.013-1.351-2.732-3.841H66.971v10.2H2.641V9.062H6.46c0,.482-.017.979,0,1.475a5.171,5.171,0,0,0,4.928,4.917c.986.016,1.745-.729,1.438-1.537a1.751,1.751,0,0,0-1.019-.979C9.434,12.367,8.793,11.519,9.1,9.062H21.916c0,.426-.009.868,0,1.311a5.179,5.179,0,0,0,4.61,5.062,3.7,3.7,0,0,0,.4.027,1.717,1.717,0,0,0,.242-.016M42.519,2.579c1.78-.007,2.711,1.36,2.549,3.8H40c-.208-2.409.723-3.8,2.517-3.8m15.571,0c1.746.065,2.661,1.487,2.418,3.8H55.441c-.124-2.514.835-3.865,2.649-3.8m-47.994.5A2.4,2.4,0,0,1,12.823,2.9c1.381.763,1.466,2.058,1.321,3.513H9.087C8.939,5.136,8.93,3.922,10.1,3.078m15.547-.06a2.4,2.4,0,0,1,2.733-.073c1.3.789,1.375,2.059,1.227,3.463H24.54c-.14-1.323-.136-2.564,1.1-3.39M8.564,1C6.723,2.348,6.317,4.285,6.447,6.442c-1.606,0-3.106,0-4.607,0C.4,6.444.012,6.825.012,8.237Q.011,32.19,0,56.143a2.408,2.408,0,0,0,.765,1.852Q5.541,62.725,10.27,67.5a2.476,2.476,0,0,0,1.907.8h.009c9.115-.015,16.27-.014,24.533-.014h7.208a3.8,3.8,0,0,0,.723-.022,1.278,1.278,0,0,0-.025-2.535,4.8,4.8,0,0,0-.8-.019H12.895c0-2.993,0-5.863,0-8.734,0-1.106-.463-1.567-1.565-1.571-2.04-.008-4.08,0-6.12,0H2.639V21.96H67.01V41.534c0,.242-.011.484,0,.725a1.284,1.284,0,1,0,2.568-.033c.013-.241,0-.483,0-.724V9.014c0-2.467-.1-2.571-2.583-2.571H63.186C62.9,2.205,61.286.133,58.243.007a5.07,5.07,0,0,0-3.57,1.212A5.69,5.69,0,0,0,52.849,6.4H47.681a6.24,6.24,0,0,0-1.022-4.324A5.065,5.065,0,0,0,42.818.014,4.972,4.972,0,0,0,39.366,1.1c-1.748,1.35-2.127,3.241-1.993,5.282h-5.12C32.022,2.254,30.359.129,27.313.007a5.079,5.079,0,0,0-3.569,1.217c-1.61,1.348-1.968,3.171-1.815,5.218H16.737a6.144,6.144,0,0,0-.959-4.3A5.063,5.063,0,0,0,11.967.017Q11.756,0,11.548,0A4.978,4.978,0,0,0,8.564,1",
    transform: "translate(0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.637,90.272h2.506v2.463H12.637Zm-1.18-2.621a1.277,1.277,0,0,0-1.418,1.388q-.031,2.456,0,4.911a1.277,1.277,0,0,0,1.389,1.418q2.455.031,4.911,0A1.3,1.3,0,0,0,17.759,93.9c.014-.777,0-1.556,0-2.334,0-.832.014-1.664,0-2.5a1.283,1.283,0,0,0-1.39-1.418q-1.22-.015-2.44-.015-1.236,0-2.47.013",
    transform: "translate(-10.024 -87.638)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ac"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.738,50.184H55.21v2.507H52.738Zm-1.265-2.6a1.259,1.259,0,0,0-1.362,1.359q-.033,2.495,0,4.991A1.259,1.259,0,0,0,51.47,55.3q2.495.033,4.991,0a1.268,1.268,0,0,0,1.364-1.36c.024-.831.005-1.663.005-2.5s.019-1.664,0-2.5a1.266,1.266,0,0,0-1.361-1.363q-1.247-.016-2.5-.016t-2.5.016",
    transform: "translate(-50.094 -47.567)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ae"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.746,50.2h2.507v2.472H72.746Zm-1.23-2.614a1.258,1.258,0,0,0-1.371,1.352q-.034,2.5,0,4.991A1.284,1.284,0,0,0,71.576,55.3c.8.017,1.61,0,2.415,0,.261,0,.524,0,.786,0,.57,0,1.14.007,1.71-.009a1.267,1.267,0,0,0,1.371-1.353q.035-2.5,0-4.991a1.258,1.258,0,0,0-1.352-1.371q-1.241-.018-2.482-.017t-2.509.016",
    transform: "translate(-70.128 -47.567)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ag"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M92.793,50.192h2.473v2.487H92.793Zm1.243-2.613c-.832,0-1.664-.019-2.5.005a1.267,1.267,0,0,0-1.361,1.362q-.032,2.5,0,4.991A1.26,1.26,0,0,0,91.54,55.3q2.495.033,4.991,0a1.26,1.26,0,0,0,1.361-1.361q.034-2.5,0-4.991a1.267,1.267,0,0,0-1.361-1.363c-.324-.009-.647-.012-.971-.012-.508,0-1.017.007-1.524.007",
    transform: "translate(-90.163 -47.573)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M112.828,50.189H115.3v2.488h-2.473Zm-1.25-2.606a1.259,1.259,0,0,0-1.363,1.359q-.032,2.5,0,4.991a1.268,1.268,0,0,0,1.359,1.365c.831.024,1.663.005,2.5.005s1.664.019,2.5-.005a1.267,1.267,0,0,0,1.363-1.36q.034-2.5,0-4.992a1.259,1.259,0,0,0-1.359-1.363q-1.248-.016-2.5-.016t-2.5.016",
    transform: "translate(-110.199 -47.567)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.73,110.3h2.487v2.473H52.73Zm-1.252-2.613a1.257,1.257,0,0,0-1.368,1.354q-.034,2.5,0,4.991a1.266,1.266,0,0,0,1.354,1.37c.831.025,1.664.005,2.5.005s1.665.019,2.5,0a1.266,1.266,0,0,0,1.368-1.356q.034-2.5,0-4.991a1.258,1.258,0,0,0-1.355-1.367q-1.241-.017-2.482-.017t-2.509.016",
    transform: "translate(-50.094 -107.672)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.692,110.274h2.464v2.507H32.692Zm1.32-2.589c-.859,0-1.718-.019-2.576.006a1.265,1.265,0,0,0-1.361,1.362q-.033,2.495,0,4.991a1.26,1.26,0,0,0,1.361,1.362q2.495.032,4.991,0a1.26,1.26,0,0,0,1.361-1.362q.033-2.495,0-4.991a1.267,1.267,0,0,0-1.362-1.363c-.313-.009-.627-.012-.94-.012-.492,0-.984.007-1.475.007",
    transform: "translate(-30.059 -107.678)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.678,50.208h2.493v2.479H32.678Zm-1.244-2.624a1.259,1.259,0,0,0-1.359,1.363q-.032,2.495,0,4.991A1.266,1.266,0,0,0,31.437,55.3c.8.024,1.61.005,2.415.005.858,0,1.718.019,2.575-.005a1.268,1.268,0,0,0,1.36-1.365q.032-2.494,0-4.991a1.26,1.26,0,0,0-1.363-1.359q-1.248-.016-2.5-.016t-2.5.016",
    transform: "translate(-30.058 -47.567)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aq"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.655,50.187h2.477v2.492H12.655Zm-1.194-2.606a1.3,1.3,0,0,0-1.423,1.468c-.014.778,0,1.556,0,2.335,0,.832-.014,1.664,0,2.5A1.283,1.283,0,0,0,11.429,55.3q2.454.03,4.91,0a1.279,1.279,0,0,0,1.419-1.388q.031-2.454,0-4.91a1.278,1.278,0,0,0-1.388-1.419q-1.228-.015-2.456-.015t-2.455.014",
    transform: "translate(-10.031 -47.567)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "as"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M92.793,90.259h2.473v2.488H92.793Zm-1.259-2.605a1.258,1.258,0,0,0-1.355,1.367q-.031,2.495,0,4.991a1.259,1.259,0,0,0,1.368,1.355q2.495.032,4.991,0A1.266,1.266,0,0,0,97.895,94c.023-.831.005-1.663.005-2.5s.019-1.664-.006-2.5a1.266,1.266,0,0,0-1.369-1.355q-1.248-.015-2.5-.016t-2.5.017",
    transform: "translate(-90.163 -87.637)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "au"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.757,90.258h2.477v2.492H72.757Zm-1.2-2.606a1.276,1.276,0,0,0-1.411,1.4q-.029,2.455,0,4.911a1.277,1.277,0,0,0,1.4,1.411q2.455.029,4.911,0a1.284,1.284,0,0,0,1.412-1.4c.021-.805,0-1.61,0-2.415,0-.832.015-1.664,0-2.5a1.283,1.283,0,0,0-1.4-1.411q-1.22-.015-2.44-.014-1.236,0-2.47.014",
    transform: "translate(-70.13 -87.638)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aw"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12.661,70.232h2.487v2.5H12.661Zm-1.217-2.615a1.277,1.277,0,0,0-1.406,1.4q-.029,2.455,0,4.911a1.277,1.277,0,0,0,1.4,1.406q2.455.029,4.91,0a1.283,1.283,0,0,0,1.407-1.4c.021-.831,0-1.664,0-2.5,0-.805.016-1.611,0-2.415a1.284,1.284,0,0,0-1.4-1.406q-1.22-.014-2.44-.014-1.236,0-2.47.014",
    transform: "translate(-10.024 -67.603)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ay"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.691,70.23h2.5v2.482h-2.5Zm-1.2-2.611a1.281,1.281,0,0,0-1.417,1.389q-.03,2.456,0,4.911a1.278,1.278,0,0,0,1.389,1.418q2.456.03,4.911,0a1.278,1.278,0,0,0,1.417-1.39q.032-2.455,0-4.91a1.3,1.3,0,0,0-1.469-1.421c-.778-.014-1.556,0-2.335,0l-.776,0-.734,0c-.329,0-.657,0-.986.01",
    transform: "translate(-30.059 -67.609)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.717,70.246H55.2V72.72H52.717Zm-1.182-2.63a1.3,1.3,0,0,0-1.428,1.462q-.022,2.415,0,4.83a1.3,1.3,0,0,0,1.461,1.429q2.415.022,4.83,0a1.3,1.3,0,0,0,1.43-1.462c.014-.778,0-1.556,0-2.335,0-.8.009-1.61,0-2.415-.014-1.011-.477-1.5-1.464-1.508q-1.225-.012-2.45-.012-1.19,0-2.38.012",
    transform: "translate(-50.096 -67.604)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bc"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.777,70.241h2.478v2.484H72.777Zm-1.258-2.623a1.283,1.283,0,0,0-1.375,1.432c-.016.778,0,1.556,0,2.334,0,.859-.016,1.718.006,2.576A1.265,1.265,0,0,0,71.5,75.331q2.495.035,4.991,0a1.26,1.26,0,0,0,1.371-1.352q.035-2.5,0-4.991a1.258,1.258,0,0,0-1.352-1.371Q75.256,67.6,74,67.6t-2.483.016",
    transform: "translate(-70.135 -67.602)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "be"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M92.806,70.238h2.477v2.491H92.806Zm-1.2-2.621a1.3,1.3,0,0,0-1.428,1.462q-.022,2.415,0,4.83a1.3,1.3,0,0,0,1.461,1.429q2.415.022,4.83,0A1.3,1.3,0,0,0,97.9,73.874c.015-.778,0-1.556,0-2.335,0-.8.009-1.61,0-2.415-.014-1.011-.477-1.5-1.464-1.508q-1.225-.012-2.45-.012-1.19,0-2.38.012",
    transform: "translate(-90.166 -67.604)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bg"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M112.838,70.2h2.46v2.5h-2.46Zm-1.25-2.585a1.283,1.283,0,0,0-1.374,1.433c-.016.8,0,1.61,0,2.415,0,.832-.017,1.664.006,2.5a1.266,1.266,0,0,0,1.354,1.369q2.5.034,4.991,0a1.258,1.258,0,0,0,1.368-1.354q.035-2.495,0-4.991a1.258,1.258,0,0,0-1.354-1.368q-1.254-.017-2.509-.017t-2.482.016",
    transform: "translate(-110.205 -67.602)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bi"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M52.719,90.284h2.507v2.467H52.719Zm-1.205-2.633a1.277,1.277,0,0,0-1.405,1.4q-.029,2.455,0,4.911a1.277,1.277,0,0,0,1.4,1.406q2.456.029,4.911,0a1.283,1.283,0,0,0,1.407-1.4c.021-.831,0-1.664,0-2.5q0-1.168,0-2.335c0-.027,0-.054,0-.081a1.294,1.294,0,0,0-1.406-1.405q-1.228-.015-2.456-.014t-2.456.014",
    transform: "translate(-50.095 -87.638)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bk"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M72.772,110.292h2.476v2.478H72.772Zm-1.2-2.606a1.3,1.3,0,0,0-1.428,1.462q-.022,2.416,0,4.83a1.3,1.3,0,0,0,1.462,1.43c.778.014,1.556,0,2.335,0,.805,0,1.61.009,2.415,0,1.01-.014,1.5-.477,1.508-1.465q.022-2.415,0-4.83a1.3,1.3,0,0,0-1.462-1.428q-1.225-.011-2.451-.011-1.189,0-2.379.012",
    transform: "translate(-70.131 -107.674)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bm"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.689,90.285H35.2v2.463H32.689Zm-1.25-2.632a1.266,1.266,0,0,0-1.362,1.361c-.024.831-.005,1.663-.005,2.5s-.019,1.664.005,2.5a1.268,1.268,0,0,0,1.362,1.362q2.495.032,4.991,0a1.26,1.26,0,0,0,1.361-1.362q.033-2.5,0-4.991a1.259,1.259,0,0,0-1.362-1.361q-1.248-.016-2.5-.016t-2.5.016",
    transform: "translate(-30.065 -87.637)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(48.66 46.326)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 21.34,
    height: 21.348,
    transform: "translate(0 0)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 69.597,
    height: 68.378,
    transform: "translate(-0.001 -0.068)"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.157 45.087)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.757,
    height: 7.751,
    transform: "translate(-0.006)"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.772 24.472)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "e"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.76,
    height: 7.752,
    transform: "translate(-0.006 0)"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.079 24.472)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.759,
    height: 7.751,
    transform: "translate(-0.006)"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.387 24.475)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "g"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.758,
    height: 7.761,
    transform: "translate(-0.005 -0.012)"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.694 24.472)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.758,
    height: 7.755,
    transform: "translate(-0.005)"
  })))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.772 55.394)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "i"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.758,
    height: 7.756,
    transform: "translate(-0.006)"
  })))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.464 55.397)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "j"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.757,
    height: 7.761,
    transform: "translate(-0.006 -0.012)"
  })))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.464 24.472)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "k"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.758,
    height: 7.755,
    transform: "translate(-0.006)"
  })))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.16 24.472)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "l"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.757,
    height: 7.752,
    transform: "translate(-0.009 0)"
  })))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.387 45.087)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "m"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.761,
    height: 7.753,
    transform: "translate(-0.006)"
  })))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.08 45.087)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.758,
    height: 7.751,
    transform: "translate(-0.005)"
  })))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.157 34.78)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "o"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.758,
    height: 7.75,
    transform: "translate(-0.005 0)"
  })))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.465 34.783)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "p"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.757,
    height: 7.754,
    transform: "translate(-0.005 -0.006)"
  })))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.773 34.78)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "q"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.753,
    height: 7.749,
    transform: "translate(-0.005 0)"
  })))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.082 34.779)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "r"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.76,
    height: 7.753,
    transform: "translate(-0.011 0)"
  })))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.388 34.78)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "s"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.753,
    height: 7.749,
    transform: "translate(-0.005)"
  })))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(56.697 34.779)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "t"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.76,
    height: 7.753,
    transform: "translate(-0.011 0)"
  })))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(25.772 45.087)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "u"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.758,
    height: 7.751,
    transform: "translate(-0.005)"
  })))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(36.08 55.395)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "v"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.754,
    height: 7.748,
    transform: "translate(-0.005 0)"
  })))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(15.467 45.087)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "w"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 7.76,
    height: 7.752,
    transform: "translate(-0.012 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarExam);
export default __webpack_public_path__ + "static/media/calendarExam.3e24019a281958dcdc88e50fa5ed7035.svg";
export { ForwardRef as ReactComponent };